
import styled from "styled-components";
import {useEffect, useState, useRef} from "react";
import {ToStartBrunch, Dips, MarketBrunch, OdeTheEgg, Panouzzi, SidesBrunch, SweetInstinct, Coffee, HotDrinks, ColdPress, ColdDrinks, SoftDrinks, Water, Indecision, FromTheClayBrunch, SoftDrinksWater} from "../../components/MenuGrids/LunchroomMenu";
import { CopyRightStyled } from "../../components/MenuGrids/HabraMenu/generalStyles";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {LoadingIcon} from "../../components";


function LunchRoomMenuBrunchEn({}){
    const url = process.env.NODE_ENV == "development" ? process.env.REACT_APP_API_URL_DEV : process.env.REACT_APP_API_URL_PROD;
    const [triggerLanguage, setTriggerLanguage] = useState("en");
    const sliderContainer = useRef(null);
    const lunchroomCatRef = useRef([]);
    const lunchRoomSectionsRef = useRef([]);
    const [menuItems, setMenuItems] = useState({});
    const [loading, setLoading] = useState(true);
    const categoriesIndices = ['0', '1', '2', '3', '4', '5', '6', '7', '8',  '9', '10', '11', '12', '13']
    const navigate = useNavigate();

    //triggers the arabic/english menu
    function handleTriggerMenu() {
        navigate("/restaurants/menus/lunchroom/brunchAr");
    }

    //activate the cateogry we click on
    function navClickHandler(e, id) {
        e.preventDefault();
        lunchRoomSectionsRef.current[id - 1]?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        activeCategoryHandler(id)
    }

    //activates/deactivates the categories that we click on or we are currently on
    function activeCategoryHandler(sectionId) {
        var index = sectionId -1;
        
        lunchroomCatRef.current[index].style.color = "#de5750";

        categoriesIndices.map((item) => {
            if(item != index) {
                lunchroomCatRef.current[item].style.color = "black";
            }
        })
    }

    //this functiont tracks the user position as he scrolls down the page
    function windowScrollTracker(currentScroll) {
        var sectionFromTop;
        var sectionId;

        //gets the id of the category we are ona s we scroll    
        lunchRoomSectionsRef.current.forEach((section) => {
            sectionFromTop = section.getBoundingClientRect().top;

            if(sectionFromTop <= 10) {
                sectionId = section.getAttribute("id");
            }
        })

        navBarTracker(sectionId);
    
    }

    async function navBarTracker(sectionId) {
    
        switch(sectionId) {
            //activates the TO START cateogry
            case '1':
                sliderContainer.current.scrollLeft = 0;
                await activeCategoryHandler(sectionId)
            break;

            //activates ODE TO THE EGG cateogory
            case '2':
                sliderContainer.current.scrollLeft = 0;
                await activeCategoryHandler(sectionId)
            break;

            //activates SIDES category
            case '3':
                sliderContainer.current.scrollLeft = 80;
                await activeCategoryHandler(sectionId)
            break;

            //activates MARKET category
            case '5':
                sliderContainer.current.scrollLeft = 100;
                await activeCategoryHandler(sectionId)
            break;
            //activates SWEET INSTINCT category
            case '6':
                sliderContainer.current.scrollLeft = 250;
                await activeCategoryHandler(sectionId)
            break;

            //activates FROM THE CLAY OVEN category
            case '7':
                sliderContainer.current.scrollLeft = 350;
                await activeCategoryHandler(sectionId);
            break;

            //activates PANOUZZO category
            case '7':
                sliderContainer.current.scrollLeft = 400;
                await activeCategoryHandler(sectionId);
            break;

            //activates the DIPS category
            case '8':
                sliderContainer.current.scrollLeft = 450;
                await activeCategoryHandler(sectionId);
            break;

             //activates the COFFEE COMMUNE category
             case '9':
                sliderContainer.current.scrollLeft = 500;
                await activeCategoryHandler(sectionId);
            break;

             //activates the COLD PRESS category
             case '10':
                sliderContainer.current.scrollLeft = 550;
                await activeCategoryHandler(sectionId);
            break;

             //activates the HOT DRINKS category
             case '11':
                sliderContainer.current.scrollLeft = 600;
                await activeCategoryHandler(sectionId);
            break;

             //activates the SOFT DRINKS & WATER category
             case '12':
                sliderContainer.current.scrollLeft = 650;
                await activeCategoryHandler(sectionId);
            break;
        }

        return "resolved";
    }

    //function to move the slider
    function useHorizontalScrollEventEn(callback) {
        const positionRef = useRef(0);

        return(e) => {
            const x = e.currentTarget.scrollLeft;
            if(x !== positionRef.current) {
                positionRef.current = x;
                callback(e);
            }
        }
    }

    //fetches all items with branch -- vendome
    async function getAllItems() {
        try {
            const link = `${url}/lunchroom?branch=vendome`;
            const {data: {items}} = await axios.get(link, {});
            console.log(items);

            const categories = {
                "TO START-BRUNCH": [],
                "ODE TO THE EGG": [],
                "SIDES-BRUNCH": [],
                "MARKET-BRUNCH": [],
                "SWEET INSTINCT": [],
                "FROM THE CLAY OVEN-BRUNCH": [],
                "PANOUZZI": [],
                "DIPS": [],
                "COFFEE COMMUNE": [],
                "HOT DRINKS": [],
                "COLD PRESS": [],
                "SOFT DRINKS & WATER": [],
   
            }
     
            items.forEach(item => {
                if(item.category && categories[item.category]) {
                    categories[item.category].push(item);
                }
            })
            setMenuItems(categories)
            setLoading(false);
        } catch (error) {
            console.log("the error recieved is: ", error.message);
        }
    }

    useEffect(() => {
        function handleScroll(e) {
            var currentScroll = window.pageYOffset;
            windowScrollTracker(currentScroll);
        }

        var timer = null;

        window.addEventListener('scroll', function() {
            if(timer !== null) {
                clearTimeout(timer)
            }
            timer = setTimeout(function() {
                handleScroll()
            }, 50)
        })
    }, [])

    useEffect(() => {
        getAllItems();
    }, [])

    if(loading) {
        return (
            <LoadingIcon/>
        )
    }

    return (
        <LunchRoomPageStyled>
                <SliderContainerStyled ref = {sliderContainer} onScroll = {useHorizontalScrollEventEn} triggerLanguage = "en">
                    <NavTextStyled>
                     
                        <a href = "#1" ref = {(el) => lunchroomCatRef.current[0]=el} onClick = {(e)=>navClickHandler(e,"1")}>
                                <span>TO START</span>
                        </a>
                    </NavTextStyled>
                    <NavTextStyled>
                        <a href = "#2" ref = {(el) => lunchroomCatRef.current[1]=el} onClick = {(e)=>navClickHandler(e, "2")}>
                                <span>ODE TO THE EGG</span>
                        </a>
                    </NavTextStyled>
                    <NavTextStyled>
                        <a href = "#3" ref = {(el) => lunchroomCatRef.current[2]=el} onClick = {(e)=>navClickHandler(e, "3")}>
                                <span>SIDES</span>
                        </a>
                    </NavTextStyled>
                    <NavTextStyled>
                        <a href = "#4" ref = {(el) => lunchroomCatRef.current[3]=el} onClick = {(e)=>navClickHandler(e, "4")}>
                                <span>MARKET</span>
                        </a>
                    </NavTextStyled>
                    <NavTextStyled>
                        <a href = "#5" ref = {(el) => lunchroomCatRef.current[4]=el} onClick = {(e)=>navClickHandler(e, "5")}>
                                <span>SWEET INSTINCT</span>
                        </a>
                    </NavTextStyled>
                    <NavTextStyled>
                        <a href = "#6" ref = {(el) => lunchroomCatRef.current[5]=el} onClick = {(e)=>navClickHandler(e, "6")}>
                                <span>FROM THE CLAY OVEN</span>
                        </a>
                    </NavTextStyled>
                    <NavTextStyled>
                        <a href = "#7" ref = {(el) => lunchroomCatRef.current[6]=el} onClick = {(e)=>navClickHandler(e, "7")}>
                                <span>PANOUZZI</span>
                        </a>
                    </NavTextStyled>
                    <NavTextStyled>
                        <a href = "#8" ref = {(el) => lunchroomCatRef.current[7]=el} onClick = {(e)=>navClickHandler(e, "8")}>
                                <span>DIPS</span>
                        </a>
                    </NavTextStyled>
                    <NavTextStyled>
                        <a href = "#9" ref = {(el) => lunchroomCatRef.current[8]=el} onClick = {(e)=>navClickHandler(e, "9")}>
                                <span>COFFEE COMMUNE</span>
                        </a>
                    </NavTextStyled>
                    <NavTextStyled>
                        <a href = "#10" ref = {(el) => lunchroomCatRef.current[9]=el} onClick = {(e)=>navClickHandler(e, "10")}>
                                <span>HOT DRINKS</span>
                        </a>
                    </NavTextStyled>
                    <NavTextStyled>
                        <a href = "#11" ref = {(el) => lunchroomCatRef.current[10]=el} onClick = {(e)=>navClickHandler(e, "11")}>
                                <span>COLD PRESS</span>
                        </a>
                    </NavTextStyled>
                    <NavTextStyled>
                        <a href = "#12" ref = {(el) => lunchroomCatRef.current[11]=el} onClick = {(e)=>navClickHandler(e, "12")}>
                                <span>SOFT DRINKS & WATER</span>
                        </a>
                    </NavTextStyled>
                  
                </SliderContainerStyled>
                {/* <TestingBlockStyled>
                        <img src = "/menuCovers/LR-OnlineMENU-CoverPage-V2.png"/>
                </TestingBlockStyled> */}
                <LanguageTriggerContainerStyled triggerLanguage = "en">
                    <span onClick = {() => handleTriggerMenu("ar")}>عربي</span>
                </LanguageTriggerContainerStyled>
                <CategoryContainerStyled>
                    <section id = "1" ref = {(el) => lunchRoomSectionsRef.current[0] = el}>
                        <ToStartBrunch triggerLanguage = {triggerLanguage} categoryItems={menuItems["TO START-BRUNCH"]}/>
                    </section>
                </CategoryContainerStyled>
                <CategoryContainerStyled>
                    <section id = "2" ref = {(el) => lunchRoomSectionsRef.current[1] = el}>
                        <OdeTheEgg triggerLanguage = {triggerLanguage} categoryItems={menuItems["ODE TO THE EGG"]}/>
                    </section>
                </CategoryContainerStyled>
                <CategoryContainerStyled>
                    <section id = "3" ref = {(el) => lunchRoomSectionsRef.current[2] = el}>
                        <SidesBrunch triggerLanguage = {triggerLanguage} categoryItems={menuItems["SIDES-BRUNCH"]}/>
                    </section>
                </CategoryContainerStyled>
                <CategoryContainerStyled>
                    <section id = "4" ref = {(el) => lunchRoomSectionsRef.current[3] = el}>
                        <MarketBrunch triggerLanguage = {triggerLanguage} categoryItems={menuItems["MARKET-BRUNCH"]}/>
                    </section>
                </CategoryContainerStyled>
                <CategoryContainerStyled>
                    <section id = "5" ref = {(el) => lunchRoomSectionsRef.current[4] = el}>
                        <SweetInstinct triggerLanguage = {triggerLanguage} categoryItems={menuItems["SWEET INSTINCT"]}/>
                    </section>
                </CategoryContainerStyled>
                <CategoryContainerStyled>
                    <section id = "6" ref = {(el) => lunchRoomSectionsRef.current[5] = el}>
                        <FromTheClayBrunch triggerLanguage = {triggerLanguage} categoryItems={menuItems["FROM THE CLAY OVEN-BRUNCH"]}/>
                    </section>
                </CategoryContainerStyled>
                <CategoryContainerStyled>
                    <section id = "7" ref = {(el) => lunchRoomSectionsRef.current[6] = el}>
                        <Panouzzi triggerLanguage = {triggerLanguage} categoryItems={menuItems["PANOUZZI"]}/>
                    </section>
                </CategoryContainerStyled>
                <CategoryContainerStyled>
                    <section id = "8" ref = {(el) => lunchRoomSectionsRef.current[7] = el}>
                        <Dips triggerLanguage = {triggerLanguage} categoryItems={menuItems["DIPS"]}/>
                    </section>
                </CategoryContainerStyled>
                <CategoryContainerStyled>
                    <section id = "9" ref = {(el) => lunchRoomSectionsRef.current[8] = el}>
                        <Coffee triggerLanguage = {triggerLanguage} categoryItems={menuItems["COFFEE COMMUNE"]}/>
                    </section>
                </CategoryContainerStyled>
                <CategoryContainerStyled>
                    <section id = "10" ref = {(el) => lunchRoomSectionsRef.current[9] = el}>
                        <HotDrinks triggerLanguage = {triggerLanguage} categoryItems={menuItems["HOT DRINKS"]}/>
                    </section>
                </CategoryContainerStyled>
                <CategoryContainerStyled>
                    <section id = "11" ref = {(el) => lunchRoomSectionsRef.current[10] = el}>
                        <ColdPress triggerLanguage = {triggerLanguage} categoryItems={menuItems["COLD PRESS"]}/>
                    </section>
                </CategoryContainerStyled>
                <CategoryContainerStyled>
                    <section id = "12" ref = {(el) => lunchRoomSectionsRef.current[11] = el}>
                        <SoftDrinksWater triggerLanguage = {triggerLanguage} categoryItems={menuItems["SOFT DRINKS & WATER"]}/>
                    </section>
                </CategoryContainerStyled>
               
                <CopyRightStyled>
                    <a href = "https://www.lovelysunnyday.com/home" target = "_blank" style = {{position: "absolute" , inset: "0",  width: "100%" , display: "flex", justifyContent: "center"}}>
                                <img src = "/Developed-By-LSD.svg"/>
                    </a>
                </CopyRightStyled>
            </LunchRoomPageStyled>
    )
}

const LunchRoomPageStyled = styled.div`
    position: relative;
    background-color:white;
    width: 100vw;
`

const SliderContainerStyled = styled.div`
    position: fixed;
    inset: 0;
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    background-color: white;
    gap: 20px;
    align-items: center;
    width: 80%;
    height: 50px;
    z-index: 1;
    overflow: scroll;
    scroll-behavior: smooth;

    &::-webkit-scrollbar {
    display: none;
  }
`

//the cover block
const TestingBlockStyled = styled.div`
    position: relative;
   
    top: 50px;

    img {
        width: 100%;
    }

`

const NavTextStyled = styled.div`
    position: relative;
    text-transform: uppercase;
    white-space: nowrap;
    font-family: "Tahoma Bold";
    font-size: 8px;
   

   span {
    z-index: 10;
    width: 100%;
   }
`

const NavTextStyledAr = styled.div`
    position: relative;
    font-family: "DIN Next LT Arabic";
    font-size: 14px;
`

const LanguageTriggerContainerStyled = styled.div`
    position: fixed;
    display: flex;
    justify-content: center;
    background-color: white;
    align-items: center;
    z-index: 1;
    inset: 0px;
    left: 80%;
    width: 20%;
    height: 50px;
    font-size: 12px;

     span {
        padding: 5px;
     }
`

const CategoryContainerStyled = styled.div`
    position: relative;
    margin-top: 80px;
`

export default LunchRoomMenuBrunchEn;
